var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMissionProveS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 245,
    viewBox: "0 0 350 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_187_6928)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_187_6928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.392 168.285C252.556 168.285 273.766 147.063 273.766 120.885C273.766 94.7072 252.556 73.4856 226.392 73.4856C200.228 73.4856 179.018 94.7072 179.018 120.885C179.018 147.063 200.228 168.285 226.392 168.285Z",
    stroke: "#6A7C89",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_187_6928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.667 168.285C157.831 168.285 179.041 147.063 179.041 120.885C179.041 94.7072 157.831 73.4856 131.667 73.4856C105.503 73.4856 84.2927 94.7072 84.2927 120.885C84.2927 147.063 105.503 168.285 131.667 168.285Z",
    stroke: "#6A7C89",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.754 238.311C238.804 238.311 289.916 187.471 289.916 124.756C289.916 62.0415 238.804 11.2012 175.754 11.2012C112.703 11.2012 61.5911 62.0415 61.5911 124.756C61.5911 187.471 112.703 238.311 175.754 238.311Z",
    stroke: "#6A7C89",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "12.47 13.95 12.47 13.95 12.47 13.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.753 231.367C234.947 231.367 282.934 183.636 282.934 124.756C282.934 65.8772 234.947 18.1462 175.753 18.1462C116.559 18.1462 68.5728 65.8772 68.5728 124.756C68.5728 183.636 116.559 231.367 175.753 231.367Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.119 216.833C265.256 195.764 289.539 137.45 268.358 86.5854C247.176 35.7205 188.55 11.566 137.413 32.6349C86.2764 53.7039 61.9929 112.018 83.1745 162.883C104.356 213.747 162.982 237.902 214.119 216.833Z",
    stroke: "#6A7C89",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "12.46 13.93 12.46 13.93 12.46 13.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5796 109.996C138.953 129.756 212.509 129.756 281.883 109.996",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1986 119.085C84.2057 113.783 83.9437 105.447 78.6135 100.467C73.2833 95.4863 64.9032 95.7468 59.8961 101.049C54.889 106.35 55.1509 114.686 60.4811 119.666C65.8112 124.647 74.1914 124.386 79.1986 119.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1986 119.085C84.2057 113.783 83.9437 105.447 78.6135 100.467C73.2833 95.4863 64.9032 95.7468 59.8961 101.049C54.889 106.35 55.1509 114.686 60.4811 119.666C65.8112 124.647 74.1914 124.386 79.1986 119.085Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.269 123.134C291.406 121.546 295.897 114.504 294.3 107.405C292.704 100.306 285.624 95.8387 278.488 97.4267C271.351 99.0148 266.859 106.057 268.456 113.156C270.053 120.255 277.132 124.722 284.269 123.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.269 123.134C291.406 121.546 295.897 114.504 294.3 107.405C292.704 100.306 285.624 95.8387 278.488 97.4267C271.351 99.0148 266.859 106.057 268.456 113.156C270.053 120.255 277.132 124.722 284.269 123.134Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.754 18.1243L147.585 75.1631H203.922L175.754 18.1243Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.754 54.6337L147.585 111.672H203.922L175.754 54.6337Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.754 195.009L203.922 137.992H147.585L175.754 195.009Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.754 231.519L203.922 174.502H147.585L175.754 231.519Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.62 174.502H185.909L175.754 195.01L165.62 174.502Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.754 54.6337L165.62 75.1633L185.909 75.1851L175.754 54.6337Z",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.753 18.1243V54.6335",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.753 193.986V230.474",
    stroke: "#6A7C89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.633 124.757C218.633 148.309 199.437 167.406 175.753 167.406C152.068 167.406 132.873 148.309 132.873 124.757C132.873 101.205 152.068 82.1074 175.753 82.1074C199.437 82.1074 218.633 101.205 218.633 124.757Z",
    fill: "url(#paint0_linear_187_6928)",
    stroke: "#6A7C89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.013 194.316C214.579 194.316 245.843 163.168 245.843 124.746C245.843 86.3233 214.579 55.1758 176.013 55.1758C137.447 55.1758 106.183 86.3233 106.183 124.746C106.183 163.168 137.447 194.316 176.013 194.316Z",
    stroke: "#6A7C89",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "12.6 14.16 12.6 14.16 12.6 14.16"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.657 132.7H163.019H161.731V111.552H177.947C182.768 111.552 186.09 114.104 187.961 117.695C188.919 119.577 189.491 121.621 189.644 123.715C189.808 125.82 189.573 127.937 188.952 129.96C187.681 134.083 184.74 137.474 180.116 138.252C178.604 138.444 177.077 138.501 175.554 138.423C175.116 138.423 174.647 138.423 173.739 138.423V135.908C174.103 135.908 174.861 135.908 175.593 135.934C176.956 136.002 178.323 135.955 179.678 135.793C183.184 135.198 185.467 132.522 186.475 129.254C186.995 127.522 187.185 125.713 187.036 123.915C186.911 122.153 186.431 120.431 185.625 118.848C184.174 116.074 181.602 114.079 177.92 114.079H164.321V130.199H166.657V132.7Z",
    fill: "#0A1214"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.872 135.895L168.073 135.929V118.227H170.663V138.414L169.371 138.427L161.881 138.401L161.872 135.895Z",
    fill: "#0A1214"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.073 117.342H177.277C177.299 117.342 183.553 117.767 183.57 125.144C183.57 132.377 178.57 132.59 176.786 132.67H176.654C175.883 132.709 171.571 132.704 168.06 132.692V130.186C171.527 130.186 175.765 130.186 176.523 130.186H176.659C177.798 130.135 180.993 129.99 180.985 125.166C180.985 120.456 177.588 119.924 177.132 119.873H168.06L168.073 117.342Z",
    fill: "#0A1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6259 119.74C74.7995 119.74 78.9936 115.568 78.9936 110.422C78.9936 105.276 74.7995 101.104 69.6259 101.104C64.4523 101.104 60.2583 105.276 60.2583 110.422C60.2583 115.568 64.4523 119.74 69.6259 119.74Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.951 119.74C287.125 119.74 291.319 115.568 291.319 110.422C291.319 105.276 287.125 101.104 281.951 101.104C276.778 101.104 272.584 105.276 272.584 110.422C272.584 115.568 276.778 119.74 281.951 119.74Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.154 231.684C180.154 230.823 179.898 229.981 179.417 229.265C178.936 228.549 178.252 227.991 177.452 227.661C176.652 227.332 175.772 227.245 174.923 227.413C174.074 227.581 173.294 227.996 172.682 228.605C172.07 229.214 171.653 229.99 171.484 230.835C171.315 231.679 171.402 232.555 171.733 233.35C172.064 234.146 172.625 234.826 173.345 235.304C174.065 235.782 174.911 236.038 175.777 236.038C176.938 236.038 178.051 235.579 178.872 234.763C179.693 233.946 180.154 232.839 180.154 231.684Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.154 18.551C180.154 17.6898 179.898 16.8476 179.417 16.1316C178.936 15.4156 178.252 14.8576 177.452 14.528C176.652 14.1985 175.772 14.1123 174.923 14.2803C174.074 14.4483 173.294 14.863 172.682 15.472C172.07 16.0809 171.653 16.8565 171.484 17.7011C171.315 18.5457 171.402 19.4217 171.733 20.2173C172.064 21.0129 172.625 21.6927 173.345 22.1711C174.065 22.6495 174.911 22.9051 175.777 22.9051C176.938 22.9051 178.051 22.446 178.872 21.6295C179.693 20.8129 180.154 19.7058 180.154 18.551Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_187_6928",
    x: 174.768,
    y: 73.2356,
    width: 103.248,
    height: 103.299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_187_6928"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_187_6928",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_187_6928",
    x: 80.0427,
    y: 73.2356,
    width: 103.248,
    height: 103.299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_187_6928"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_187_6928",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_187_6928",
    x1: 175.766,
    y1: 81.8508,
    x2: 175.625,
    y2: 168.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.467477,
    stopColor: "#34DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6FFE5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_187_6928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 239,
    height: 235,
    fill: "white",
    transform: "translate(56 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionProveS);
export default __webpack_public_path__ + "static/media/missionProveS.25264683df6a4fdbe0d7a4ad43c6deaf.svg";
export { ForwardRef as ReactComponent };